<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">Properties </div>
      <div class="scaffold-editor-panel-sub-heading">
        {{settings[propertiesItem.type].Name}} Settings
      </div>
    </div>
    <div>
      <button style="background-color: #fff;" nbButton ghost status="info" size="giant" (click)="setPropertiesSelection(null)" aria-label="Close properties panel"><nb-icon pack="fas" icon="times"></nb-icon></button>
    </div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">
    <app-controls [fileSet]="fileSet" *ngFor="let control of settings[propertiesItem.type].settings" [item]="control" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="comments" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="hidden" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
  </div>
</div>
